import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  card: {
    borderRadius: '10px',
    backgroundColor: '#fff',
    padding: '1.5rem',
    border: '1px solid #e8e8e8',

    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.05)',
    transition: 'box-shadow 0.2s ease, transform 0.2s ease',
    '&:hover': {
      boxShadow: '0 8px 28px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
      transform: 'translateY(-2px)'
    }
  },
  cardDisabled: {
    opacity: 0.55,
    pointerEvents: 'none',

  },
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1rem',
    justifyContent: 'space-between'
  },
  body: {
    flex: 1,
    width: '100%'
  },
  header: {
    display: 'flex',
    gap: '3rem',
    marginBottom: '0',
    alignItems: 'flex-start'
  },
  headerWithStatus: {
    marginBottom: '1rem'
  },
  typeSection: {
    minWidth: '150px'
  },
  descriptionSection: {
    flex: 1
  },
  label: {
    fontSize: '0.6875rem',
    color: '#9e9e9e',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '0.375rem',
    fontWeight: 500
  },
  title: {
    fontWeight: 600,
    fontSize: '0.9375rem',
    color: '#1a1a1a'
  },
  description: {
    fontSize: '0.875rem',
    color: '#5c5e6e',
    lineHeight: 1.5
  },
  statusBox: {
    padding: '0.625rem 1rem',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },
  statusSuccess: {
    backgroundColor: '#ecfdf5',
    border: '1px solid #a7f3d0'
  },
  statusError: {
    backgroundColor: '#fef2f2',
    border: '1px solid #fecaca'
  },
  statusText: {
    fontSize: '0.8125rem',
    fontWeight: 500
  },
  statusTextSuccess: {
    color: '#065f46'
  },
  statusTextError: {
    color: '#991b1b'
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    alignItems: 'flex-end',
    flexShrink: 0
  },
  migrateButton: {
    fontSize: '0.875rem',
    flexShrink: 0,
    textAlign: 'center'
  }
});

export default useStyles;
